export default __webpack_public_path__ + "static/media/romb_bg.ab3e6cdd.png";